<template>
    <div class="btn-group">
        <button class="btn bg-white border dropdown-toggle" href="#" id="dropdownMenuButton1" role="button"
            data-bs-toggle="dropdown" aria-expanded="false">
            <span v-if="selectedMember">
                <small class="text-muted">{{ selectedMember.firstName }}</small>
            </span>
            <small v-else class="text-muted">Chauffeurs...</small>
        </button>
        <ul class="dropdown-menu member-dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li v-for="member in this.members" :key="member.id">
                <a v-on:click="$emit('memberChange', member)" href="#" class="dropdown-item">
                    <small class="text-muted">{{ member.firstName }} {{ member.lastName }}</small>
                </a>
            </li>
        </ul>
    </div>
</template>


<script>
import MissionMemberService from '@/services/missionMember.service.js'
import FormatHelper from '@/helpers/format.helper.js'

export default {
    props: ['selectedMemberId'],
    watch: {
        selectedMemberId: function () {
            this.setSelectedMember(this.selectedMemberId);
        }
    },
    emits: ['memberChange'],
    data() {
        return {
            members: null,
            selectedMember: null
        }
    },
    mounted() {
        this.getMembers();
    },
    methods: {
        getMembers() {
            MissionMemberService.getList()
                .then(response => {
                    this.members = FormatHelper.missionMembersFormat(response.data);
                    this.setSelectedMember(this.selectedMemberId);
                    this.$emit('memberChange', this.selectedMember);
                })
                .catch(e => {
                    console.log(e);
                });
        },
        setSelectedMember(mId) {
            if (this.members != null && mId != null) {
                this.members.forEach(member => {
                    if (member.id == mId) {
                        this.selectedMember = member;
                    }
                });
            }
        }
    }
}
</script>

<style scoped>
.member-dropdown-menu {
    max-height: min(70vh, 420px);
    overflow-y: auto;
    overflow-x: hidden;
}
</style>